export const HUMMINGBIRD_MODE_ALIAS_PREFIX = 'hummingbird-';
export const HUMMINGBIRD_CONTEXT_SELECTION_ID = 'hummingbird-context';

type HummingbirdSelectedText = {
  id: string;
  text: string;
};

export const stripHummingbirdModeAlias = (
  mode: string | null | undefined
): string | undefined => {
  if (!mode) return undefined;
  return mode.startsWith(HUMMINGBIRD_MODE_ALIAS_PREFIX)
    ? mode.slice(HUMMINGBIRD_MODE_ALIAS_PREFIX.length)
    : mode;
};

export const getHummingbirdDraftContext = (
  selectedTexts: readonly HummingbirdSelectedText[] | undefined
): string | undefined =>
  selectedTexts?.find(
    (selection) => selection.id === HUMMINGBIRD_CONTEXT_SELECTION_ID
  )?.text;

export const replaceHummingbirdDraftContext = (
  selectedTexts: readonly HummingbirdSelectedText[],
  draftContext: string | undefined
): HummingbirdSelectedText[] => {
  const nextSelectedTexts = selectedTexts.filter(
    (selection) => selection.id !== HUMMINGBIRD_CONTEXT_SELECTION_ID
  );
  if (draftContext?.trim()) {
    nextSelectedTexts.push({
      id: HUMMINGBIRD_CONTEXT_SELECTION_ID,
      text: draftContext,
    });
  }
  return nextSelectedTexts;
};
